import { useEffect, useState } from 'react';

export const useRequest = () => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!ready) {
            return undefined;
        }

        const timeout = setTimeout(() => {
            setReady(false);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [ready]);

    const request = async (handler, callback, errorHandler) => {
        setError(false);
        setLoading(true);
        setReady(false);

        try {
            const response = await handler();

            if (response?.error) {
                throw new Error(response?.message);
            }

            const contentType = response?.headers && response.headers.get('Content-Type');

            if (contentType && contentType.includes('application/json')) {
                const { message, error, data } = await response.json();
                if (error) {
                    const errorInstance = Error(message || error);
                    errorInstance.status = response.status;
                    throw errorInstance;
                }

                callback && callback(data);
            } else {
                callback && callback(response);
            }

            setReady(true);
        } catch (e) {
            setError(e ? e.error || e.message : 'Something went wrong, try later...');
            errorHandler && errorHandler(e);
            setReady(false);
        } finally {
            setLoading(false);
        }
    };

    return {
        request,
        loading,
        error,
        ready,
    };
};
